import Vue from 'vue';
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import * as customRules from './custom.rules';
import tr from 'vee-validate/dist/locale/tr';

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

Object.keys(customRules).forEach(customRule => {
  extend(customRule, customRules[customRule]);
});

localize('tr', tr);

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
